import React, { Component, PropTypes } from 'react';

export default class WistiaPlayer extends Component {
    static propTypes = {
        videoId: PropTypes.string.isRequired,
        wq: PropTypes.array.isRequired,
        playerOptions: PropTypes.object,

        play: PropTypes.bool,

        onEnd: PropTypes.func,
        onPlay: PropTypes.func,
        onPause: PropTypes.func,
        onSecondChange: PropTypes.func,
        onTimeChange: PropTypes.func
    }

    state = { }

    handleProps() {
        const { video } = this.state;

        if(!video) {
            return;
        }
        
        this.props.onReady && this.props.onReady(video);

        if(this.props.play) {
            video.play();
        } else {
            video.pause();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { video } = this.state;
        if(!video) {
            return;
        }

        if(typeof nextProps.timeValue !== 'undefined' && Math.abs(nextProps.timeValue - video.time()) > 0.3 ) {
            video.time(nextProps.timeValue);
        }

        if(this.props.play && !nextProps.play) {
            video.pause();
        } else if(!this.props.play && nextProps.play) {
            video.play();
        }
        
    }

    componentDidMount() {
        const { wq, videoId: id, playerOptions: options } = this.props;

        wq.push({
            id,
            onReady: this.onReady,
            options
        });
    }

    onReady = video => {
        video.bind('end', this.props.onEnd);
        video.bind('play', this.props.onPlay);
        video.bind('pause', this.props.onPause);
        video.bind('secondchange', this.props.onSecondChange);
        video.bind('timechange', this.props.onTimeChange);

        this.setState({ video }, () => this.handleProps());
    }

    render() {
        const { videoId, className: additionalClasses = '' } = this.props;
        const className = `wistia_embed wistia_async_${videoId} ${additionalClasses}`;
        
        return (
            <div className={className}>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/WistiaPlayer.jsx